import { render, staticRenderFns } from "./_story.vue?vue&type=template&id=432499e8"
import script from "./_story.vue?vue&type=script&lang=js"
export * from "./_story.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports